import {
  CrownTwoTone,
  HomeOutlined,
  MailTwoTone,
} from '@ant-design/icons';
import { Breadcrumb, Button, Divider, Modal } from 'antd';
import Header from 'components/header';
import PageWrapper from 'components/pageWrapper';
import { useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { logout } from 'services/api/users';
import DomainContext from 'services/domainContext';
import ProfileContext from 'services/profileContext';
import { PLAN } from 'utils/constants';
import { usePostHogFeatureFlag } from 'hooks/usePostHogFeatureFlag';
import styles from 'styles/settings.module.scss';
import {
  isRejectedValidation,
} from 'utils/profileValidation';

const Settings = () => {
  const { profile, clearProfile } = useContext(ProfileContext);
  const { domains } = useContext(DomainContext);
  const navigate = useNavigate();
  const proPlansEnabled = usePostHogFeatureFlag('pro-plan');

  const currentPlan = profile?.plan || PLAN.FREE;
  const isPro = currentPlan === PLAN.PRO;

  if (isRejectedValidation(profile, domains)) {
    return <Navigate to="/dashboard" replace />;
  }

  const resetPasswordFunction = () => {
    logout(() => {
      navigate('/forgot-password');
      clearProfile();
    });
  };

  return (
    <>
      <Header />
      <div className={styles.wrapper}>
        <PageWrapper width={900}>
          <Breadcrumb
            items={[
              {
                title: (
                  <a href="/#/dashboard">
                    <HomeOutlined />
                    &nbsp;Dashboard
                  </a>
                ),
              },
              {
                title: 'Settings',
              },
            ]}
          />
          <h1>Settings</h1>
          <div className={styles.accountInfo}>
            <div className={styles.accountInfoElement}>
              <div className={styles.label}>
                <MailTwoTone twoToneColor={'#08a87f'} />
                &nbsp;Email
              </div>
              <div>{profile.email}</div>
              <br />
              <br />
              <div>
                <Button onClick={resetPasswordFunction} type={'primary'} ghost>
                  Update password
                </Button>
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          {proPlansEnabled && (
            <>
              <div>
                <h2>
                  <CrownTwoTone twoToneColor={'#08a87f'} />
                  &nbsp;Subscription
                </h2>
                <div className={styles.accountInfo}>
                  <div className={styles.accountInfoElement}>
                    <div style={{ marginBottom: 16 }}>
                      Current plan: <strong>{isPro ? 'Pro' : 'Free'}</strong>
                    </div>
                    <Button
                      onClick={() => navigate('/plan')}
                      type="primary"
                      ghost
                    >
                      Manage Plan
                    </Button>
                  </div>
                </div>
              </div>
              <br />
              <br />
              <br />
            </>
          )}
          <div>
            <h2>List of domains</h2>
            <div className={styles.domainList}>
              {domains.map((d, i) => (
                <div key={d._id}>
                  <div className={styles.domainWrapper}>
                    <div className={styles.domainName}>{d.name}</div>
                    <div className={styles.domainAction}>
                      <Button
                        type="primary"
                        danger
                        ghost
                        onClick={() => {
                          Modal.error({
                            content:
                              'Please contact the support to remove a domain.',
                          });
                        }}
                      >
                        Remove
                      </Button>
                    </div>
                  </div>
                  {i < domains.length - 1 && <Divider />}
                </div>
              ))}
            </div>
          </div>
        </PageWrapper>
      </div>
    </>
  );
};

export default Settings;
